<template>
  <div>
    <v-card flat class="mt-5">
      <h5>DISPENSER</h5>
      <v-data-table
        :headers="[
          {text: 'AVSER', sortable: false, filterable: false, value: 'professionId', width: '340'},
          {text: 'UTFÄRDAT', sortable: false, filterable: false, value: 'approvedOn', width: '120'},
          {text: 'INSKICKAT AV', filterable: false, value: 'issuedBy', width: '170'},
          {text: 'STATUS', sortable: false, filterable: false, value: 'state', width: '160'},
          {text: '', filterable: false, value: 'actions'}
        ]"
        :items="IEs"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        hide-default-footer
        item-key="id"
      >
        <template slot="item.professionId" slot-scope="props">{{
          getProfessionNameById(props.item.professionId)
        }}</template>
        <template slot="item.approvedOn" slot-scope="props">{{ issuedDate(get(props, 'item', null)) | date }}</template>
        <template slot="item.issuedBy" slot-scope="props">
          <div>
            {{ issuerName(props.item) }}
          </div>
        </template>

        <template slot="item.state" slot-scope="props">
          <div v-if="props.item">
            <!--  <span v-if="!showApprove(props.item) && !props.item.approvedOn && props.item.appliedById && !props.item.issuedById"> </span> -->
            <span v-if="!props.item.approvedOn" class="small">
              {{ canUserApprove(props.item) ? 'Väntar på godk.' : 'Väntar på godkännande av annan regionär.' }}
            </span>
            <span v-else class="small">
              Godkänd.
            </span>
          </div>
        </template>

        <template slot="item.actions" slot-scope="props">
          <span :data-cy-id = "props.item.id" ></span>
          <div class="d-flex justify-end">
            <v-btn
              class="ml-4"
              data-cy="delete-exemption"
              color="secondary"
              @click="
                ieMode = 'edit'
                ieModalObj = props.item
                ieModal = true
              "
            >
              Visa / Ändra
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <v-dialog v-model="ieModal" :max-width="ieMode === 'copy' ? '900px' : '670px'">
        <PersonInstructorExemptionsModal
          @approve="editOrApprove"
          :ie="ieModalObj"
          @create="create"
          @delete="deleteExemption"
          @edit="editExemption"
          @close="ieModal = false"
          :mode="ieMode"
        />
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import API from '@/services/api'
import {UserRules} from '@/components/mixins'
import PersonInstructorExemptionsModal from '@/components/person/PersonInstructorExemptionsModal'
import {pageSize} from '@/store/constants'
import get from 'lodash/get'
// @group Person
// PersonInstructorExemptions component
export default {
  name: 'PersonInstructorExemptions',
  mixins: [UserRules],
  props: {
    initialMode: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    ieModal: false,
    ieMode: '',
    ieModalObj: {},
    itemsPerPage: pageSize
  }),
  components: {
    PersonInstructorExemptionsModal
  },
  watch: {
    initialMode(newValue) {
      if (this.initialMode == 'Dispens') {
        this.ieMode = 'create'
        this.ieModal = true
      }
    }
  },

  computed: {
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),
    ...mapGetters('basic', ['getProfessionNameById', 'getRegionNameById', 'approvedByByn']),

    IEs() {
      if (this.selectedPerson.instructorExemptions) {
        return this.selectedPerson.instructorExemptions
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapActions('person', ['setSelectedPerson']),

    get,

    issuedDate(ie = {}) {
      return get(ie, 'approvedOn', null) ?? null
    },

    issuerName(item = null) {
      if ( !item ) return ''

      let firstName, lastName = ''

      if ( item?.issuedById ) {
        firstName = item.issuedBy.firstName
        lastName = item.issuedBy.lastName
      } 

      //- Return issuer name when creating ie from minasidor
      if ( item?.appliedById ) {
        firstName = item.appliedBy.firstName
        lastName = item.appliedBy.lastName
      }

      return `${ firstName } ${ lastName }`
    },

    canUserApprove(ie) {
      return this.currentUser.id !== ie.issuedById
    },

    /**
     * @vuese
     * Used to check if issued is comming from third parties in this case mina sidor or is comming from byn regionar
     * @arg The argument is object values representing instructor exemption
     */
    editOrApprove(ie) {
      if (ie && ie.issuedById) {
        this.approve(ie)
      } else {
        this.issueExemption(ie)
      }
    },
    /**
     * @vuese
     * Used to create instructor exemption
     * @arg The argument is object values representing instructor exemption
     */
    async create(ie) {
      const res = await this.$dialog.confirm({
        text: `Dispens för ${this.selectedPerson.firstName} ${this.selectedPerson.lastName}`,
        title: 'Vill du verkligen utfärda dispens?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel', outlined: true},
          {text: 'Utfärda', key: true, icon: '$sl-check'}
        ]
      })
      if (res !== true) return
      ie.personId = this.selectedPerson.id
      this.ieModal = false
      API.createInstructorExemptions({data: ie})
        .then(res => {
          this.fetchPerson()
        })
        .catch(error => {
          console.log(error)
        })
    },
    /**
     * @vuese
     * Used to issueExemption instructor exemption
     * @arg The argument is integer values representing person who issues
     */
    issueExemption(ie) {
      this.ieModal = false

      API.issueExemption(ie.id, {data: { validTo: null, personId: this.selectedPerson.id }})
        .then(res => {
          ie.issuedBy = {}
          ie.issuedOn = new Date()
          ie.issuedById = this.currentUser.id
          ie.issuedBy.id = this.currentUser.id
          ie.issuedBy.firstName = this.currentUser.firstName
          ie.issuedBy.lastName = this.currentUser.lastName
          this.fetchPerson()
          this.$events.fire('showInfo', 'Sparad.')
        })
        .catch(error => {
          console.log(error)
        })
    },
    /**
     * @vuese
     * Used to approve instructor exemption
     * @arg The argument is integer values representing person who approved
     */
    approve(ie) {
      this.ieModal = false

      API.approveInstructorExemptions(ie.id)
        .then(res => {
          ie.approvedBy = {}
          ie.approvedOn = new Date()
          ie.approvedById = this.currentUser.id
          ie.approvedBy.id = this.currentUser.id
          ie.approvedBy.firstName = this.currentUser.firstName
          ie.approvedBy.lastName = this.currentUser.lastName
          this.$events.fire('showInfo', 'Sparad.')
          this.fetchPerson()
        })
        .catch(error => {
          console.log(error)
        })
    },

    editExemption(ie) {
      this.ieModal = false

      let prepareData = {
        id: ie.id,
        exemptionReason: ie.exemptionReason ? ie.exemptionReason : null,
        professionId: ie.professionId ? ie.professionId : null,
        regionId: ie.regionId ? ie.regionId : null
      }

      API.updateExemption(prepareData.id, {data: prepareData})
        .then(res => {
          if (res && res.data && res.data.updatedRows) {
            this.fetchPerson()
          }

          this.$events.fire('showInfo', 'Uppdaterad.')
        })
        .catch(error => {
          console.log(error)
        })
    },
    async deleteExemption(ie) {
      this.ieModal = false

      const res = await this.$dialog.confirm({
        text: 'Radering av dispen går inte att ångra.',
        title: `Vill du radera dispens för ${this.selectedPerson.firstName} ${this.selectedPerson.lastName}?`,
        actions: [
          {text: 'Radera', key: true},
          {text: 'Avbryt', key: false, icon: '$sl-cancel', outlined: true}
        ]
      })
      if (res !== true || (!ie && !ie.id)) return

      API.deleteExemption(ie.id)
        .then(res => {
          this.selectedPerson.instructorExemptions
          this.selectedPerson.instructorExemptions.splice(this.selectedPerson.instructorExemptions.indexOf(ie), 1)
          this.selectedPerson.instructorExemptions = [...this.selectedPerson.instructorExemptions]
          this.$events.fire('showInfo', 'Raderad.')
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchPerson() {
      /**
       * @vuese
       * Used to fetch person
       * @arg The argument is integer values representing person id
       */
      API.getPerson(this.selectedPerson.id)
        .then(response => {
          /**
           * @vuese
           * Used to update local store with the person data
           * @arg the argument is an object representing person
           */
          this.setSelectedPerson(response.data)
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    }
  }
}
</script>

<style>
</style>
